module.exports = {
  title: '店铺直通车',
  route: {
    path: '/merchant-manage',
    children: {
      path: 'shop-brt',
    },
  },
};
